import React, { useState, useRef } from 'react';
import '../SingleNavbar/singleNavbar.css';

import Dinax_logo from '../../pictures/DSwhite.jpg';
import Text from '../Text/index';

import { Link } from 'react-router-dom';

import useClickOutside from '../../../hooks/useClickOutside';
import DropdownMenu from '../DropdownMenu/DropdownMenu';

import AdvanceDropdownMenu from '../AdvanceDropdownMenu/AdvanceDropdownMenu';

const SingleNavbar = () => {
  const [isOpen, setOpen] = useState();
  const menuRef = useRef(null);
  useClickOutside(menuRef, () => {
    if (isOpen) setTimeout(() => setOpen(false), 50);
  });

  const [isVisible, setVisible] = useState(false);
  const refOborudovanie = useRef(null);
  useClickOutside(refOborudovanie, () => setVisible(false));
  const handleMouseOverOborudovanie = () => {
    setVisible(true);
  };

  const handleMouseOutOborudovanie = () => {
    setVisible(false);
  };

  const [isSee, setIsSee] = useState(false);
  const refUslugi = useRef(null);
  useClickOutside(refUslugi, () => setIsSee(false));
  const handleMouseOverUslugi = () => {
    setIsSee(true);
  };

  const handleMouseOutUslugi = () => {
    setIsSee(false);
  };

  return (
    <div className="singleNavbar">
      <span className="singleNavbar__logo">
        <Link to="/">
          <img src={Dinax_logo} alt="" />
        </Link>
      </span>

      <nav
        className={`singleNavbar__nav ${isOpen ? 'active-open' : ''} `}
        ref={menuRef}
      >
        <ul className="singleNavbar__list">
          <li
            id="menu"
            className="singleNavbar__list-item"
            style={{ backgroundColor: `#3b7b2b`, textAlign: `center` }}
          >
            <Text component="a" href="/" size="sm">
              Меню
            </Text>
          </li>
          <li
            className="singleNavbar__list-item"
            ref={refUslugi}
            onMouseOver={handleMouseOverUslugi}
            onMouseOut={handleMouseOutUslugi}
          >
            <button onClick={() => setIsSee(!isSee)}>
              <Link to="/services">
                <Text component="span" size="md" title="Что мы умеем?">
                  Наши работы
                </Text>
              </Link>
            </button>

            {isSee && (
              <DropdownMenu
                page="uslugi"
                items={[
                  {
                    id: 19,
                    title: 'Шкаф управления пожарной насосной станцией',
                    link: '#redcupboard',
                    address: '/services#redcupboard',
                  },
                  {
                    id: 20,
                    title: 'Шкаф управления задвижками на очистных сооружениях',
                    link: '#cupboard_wastewater',
                    address: '/services#cupboard_wastewater',
                  },
                  {
                    id: 21,
                    title: 'Шкаф управления насосной станцией',
                    link: '#cupboard_station',
                    address: '/services#cupboard_station',
                  },
                  {
                    id: 22,
                    title:
                      'Шкаф автоматики установкой разогрева элементов формовки кожаных перчаток',
                    link: '#cupboard_leathergoods',
                    address: '/services#cupboard_leathergoods',
                  },
                  {
                    id: 23,
                    title: 'Шкаф управления системы вентиляции',
                    link: '#cupboard_ventilation',
                    address: '/services#cupboard_ventilation',
                  },
                  {
                    id: 24,
                    title: 'Силовой шкаф учета с устройством АВР',
                    link: '#cupboard_ABP',
                    address: '/services#cupboard_ABP',
                  },
                  {
                    id: 25,
                    title:
                      'Шкаф автоматики плавучей насосной станции с управлением пo радиоканалу',
                    link: '#cupboard_swiming',
                    address: '/services#cupboard_swiming',
                  },
                  {
                    id: 26,
                    title: 'Шкаф автоматики и управления конвейерными лентами',
                    link: '#cupboard_ribbon',
                    address: '/services#cupboard_ribbon',
                  },
                  {
                    id: 27,
                    title:
                      'Шкаф управления пожарной насосной станцией на релейной автоматике',
                    link: '#cupboard_firesafary',
                    address: '/services#cupboard_firesafary',
                  },
                  {
                    id: 28,
                    title: 'Шкаф управления задвижками на очистных сооружениях',
                    link: '#cupboard_clean',
                    address: '/services#cupboard_clean',
                  },
                ]}
              />
            )}
          </li>

          <li
            className="singleNavbar__list-item"
            ref={refOborudovanie}
            onMouseOver={handleMouseOverOborudovanie}
            onMouseOut={handleMouseOutOborudovanie}
          >
            <button onClick={() => setOpen(!isOpen)}>
              <Link to="/equipping">
                <Text component="span" size="md" title="С чем мы работаем?">
                  Оборудование
                </Text>
              </Link>
            </button>
            {isVisible && (
              <DropdownMenu
                page="oborudovanie"
                items={[
                  {
                    id: 0,
                    title: 'TDM ELECTRIC',
                    link: '#equipping_TDM',
                    address: '/equipping#equipping_TDM',
                  },
                  {
                    id: 1,
                    title: 'EKF',
                    link: '#equipping_EKF',
                    address: '/equipping#equipping_EKF',
                  },
                  {
                    id: 2,
                    title: 'DKC',
                    link: '#equipping_DKC',
                    address: '/equipping#equipping_DKC',
                  },
                  {
                    id: 3,
                    title: 'SYSTEME ELECTRIC',
                    link: '#equipping_SystemElectric',
                    address: '/equipping#equipping_SystemElectric',
                  },
                  {
                    id: 4,
                    title: 'ABB',
                    link: '#equipping_ABB',
                    address: '/equipping#equipping_ABB',
                  },
                  {
                    id: 5,
                    title: 'IEK',
                    link: '#equipping_IEK',
                    address: '/equipping#equipping_IEK',
                  },
                  {
                    id: 6,
                    title: 'OSTEC',
                    link: '#equipping_OSTEC',
                    address: '/equipping#equipping_OSTEC',
                  },

                  {
                    id: 7,
                    title: 'LEGRAND',
                    link: '#equipping_Legrand',
                    address: '/equipping#equipping_Legrand',
                  },
                  {
                    id: 8,
                    title: 'DEKRAFT',
                    link: '#equipping_DEKraft',
                    address: '/equipping#equipping_DEKraft',
                  },
                  {
                    id: 9,
                    title: 'PHOENIX CONTACT',
                    link: '#equipping_PhoenixContact',
                    address: '/equipping#equipping_PhoenixContact',
                  },
                  {
                    id: 10,
                    title: 'КЭАЗ',
                    link: '#equipping_КЭАЗ',
                    address: '/equipping#equipping_КЭАЗ',
                  },
                  {
                    id: 11,
                    title: 'WEIDMULLER',
                    link: '#equipping_WEIDMULLER',
                    address: '/equipping#equipping_WEIDMULLER',
                  },
                  {
                    id: 12,
                    title: 'SIEMENS',
                    link: '#kontrollery_SIEMENS',
                    address: '/controllers#kontrollery_SIEMENS',
                  },
                  {
                    id: 13,
                    title: 'UNITRINICS',
                    link: '#kontrollery_UNITRINICS',
                    address: '/controllers#kontrollery_UNITRINICS',
                  },
                  {
                    id: 14,
                    title: 'ONI',
                    link: '#kontrollery_ONI',
                    address: '/controllers#kontrollery_ONI',
                  },
                  {
                    id: 15,
                    title: 'HELMHOLZ',
                    link: '#kontrollery_HELMHOLZ',
                    address: '/controllers#kontrollery_HELMHOLZ',
                  },
                  {
                    id: 16,
                    title: 'OBEH',
                    link: '#kontrollery_OBEH',
                    address: '/controllers#kontrollery_OBEH',
                  },
                  {
                    id: 17,
                    title: 'GCAN',
                    link: '#kontrollery_GCAN',
                    address: '/controllers#kontrollery_GCAN',
                  },
                  {
                    id: 18,
                    title: 'SEGNETICS',
                    link: '#kontrollery_SEGNETICS',
                    address: '/controllers#kontrollery_SEGNET',
                  },
                ]}
              />
            )}
          </li>

          <li className="singleNavbar__list-item">
            <Link to="/dostavka">
              <Text
                component="a"
                href="/dostavka"
                size="md"
                title="Как получить?"
              >
                Доставка и оплата
              </Text>
            </Link>
          </li>
          <li className="singleNavbar__list-item">
            <Link to="/fill_the_form">
              <Text
                component="a"
                href="/fill_the_form"
                size="md"
                title="Как связаться?"
              >
                Контакты
              </Text>
            </Link>
          </li>
          <li className="singleNavbar__list-item">
            <Link to="/okompanuu">
              <Text component="a" size="md" title="Кто мы?">
                О компании
              </Text>
            </Link>
          </li>
          {/* <li className="singleNavbar__list-item">
            <Text component="a" href="/" size="md">
              Информация о юридическом лице
            </Text>
          </li> */}
        </ul>
      </nav>
      <AdvanceDropdownMenu />
    </div>
  );
};

export default SingleNavbar;
